/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { apiFetch } from '../../../apiClient';
import history from '../../../utils/history';
import paths from '../../../config/path';
import { apiMap } from '../../../config/constants';
import { savePQForm, applicantInformationHandleAction } from '../state/action';
import BasePage from '../../../shared/BasePage';
import ApplicantInformationItem from '../components/ApplicantInformationItem';
import { Grid } from 'react-bootstrap';
import { isStringEmpty, setTitle } from '../../../utils';
import StepIndicator from '../../../shared/StepIndicator';
import FormTitle from '../../../shared/AOForm/components/FormTitle';
import { isCardNo } from '../../../utils/ValidationUtils';
import { updateStep } from '../../CompanyRegistration/state/action';
import AOForm from '../../../shared/AOForm';

import '../style/ApplicantInformation.css'
/* eslint-disable array-callback-return */
class ApplicantInformation extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            privacy: '',
            errorList: [],
            errorMsgs: {}
        }
    }

    componentDidMount() {
        this.getDefaultAnswer(this.props);
        this.loadContentMessage();
    }
    componentWillReceiveProps = (nextProps) => {
        this.getDefaultAnswer(nextProps);
        if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.loadContentMessage();
            this.setState({
                errorList: [],
                errorMsgs: {}
            })
        }
    }
    loadContentMessage = () => {
        //this.props.getMessage('applicantInformationI18n', 'i18n');
        apiFetch(apiMap.applicantInformationI18n)().then((i18n) => {
            if (i18n) {
                this.props.applicantInformationHandleAction({ i18n });
            }
        }).catch(error => {});
    };
    getDefaultAnswer = (props) => {
        const { appInfo } = props;
        const { currentSection } = this.state;
        if (appInfo){
            const { idInfo } = appInfo;
            if (currentSection) {
                this.setState({
                    currentSection: Object.assign({}, idInfo, currentSection)
                })
            } else {
                this.setState({
                    currentSection: {
                        name: (idInfo && idInfo.name) || '',
                        idType: (idInfo && idInfo.idType) || '000',
                        otherIdType: (idInfo && idInfo.otherIdType) || '',
                        idNo: (idInfo && idInfo.idNo) || '',                    
                        privacy: this.state.privacy || ''
                    }
                })
            }
        }
    }
    onChangeAnswerForm = (value, questionID) => {
        const { currentSection, errorList } = this.state;
        const itemIndex = errorList.indexOf(questionID);
        if (itemIndex !== -1) {
            errorList.splice(itemIndex, 1);
        }
        // if (questionID === 'idType' &&  value !== 1) { this.removeErrorList(errorList, 'idNo'); }
        if (questionID === 'idType') {
            if(value === '000'){
                currentSection[questionID] = '';
            } else {
                if(value !== 1){
                    this.removeErrorList(errorList, 'idNo');
                }
                currentSection[questionID] = value;
            }
        } else {
            currentSection[questionID] = value;
        }
        this.setState({
            currentSection
        })
    };
    onBlurAction = (value, questionID) => {
        this.isValid(value, questionID);
        const { errorList } = this.state;
        this.setState({
            errorList
        })
    }
    isValid = (value, questionID) => {
        const { errorList, errorMsgs, currentSection} = this.state;
        const { i18n } = this.props;
        const requireMsg = i18n.errorMsg[questionID] && i18n.errorMsg[questionID];
        if (isStringEmpty(value)) {
            this.addError(errorList, questionID);
            errorMsgs[questionID] = requireMsg || i18n.requireMsg;
        } else if ((questionID === 'idNo' && currentSection.idType === 1 && !isCardNo(value)) ||
            (currentSection.idNo !== '' && questionID === 'idType' &&  value === 1  && !isCardNo(currentSection.idNo)
        )) {
            this.addError(errorList, 'idNo');
            errorMsgs['idNo'] = this.props.i18n.idNo.errorMsg;
        } else if(questionID === 'idType' &&  value === '000'){
            this.addError(errorList, 'idType');
            errorMsgs['idType'] = i18n.errorMsg[questionID];
        } else {
            if (questionID === 'idType' &&  value !== 1) this.removeErrorList(errorList, 'idNo');
            this.removeErrorList(errorList, questionID);
        };
    }
    // Validation
    validateForm = () => {
        return new Promise((resolve, reject) => {
            const { currentSection, errorList } = this.state;
            this.validateQuestion(currentSection, errorList);
            this.setState({
                errorList
            }, () => {
                const { errorList } = this.state;
                if (errorList && errorList.length > 0) {
                    reject && reject(errorList)
                } else {
                    resolve && resolve()
                }
            });
        });
    }
    addError = (errorList, errorItem) => {
        if (errorList.indexOf(errorItem) === -1) {
            errorList.push(errorItem);
        }
    }
    removeErrorList = (errorList, errorItem) => {
        const index = errorList.indexOf(errorItem);
        if (index !== -1) {
            errorList.splice(index, 1);
        }
    }
    validateQuestion = (questions, errorList, initalState) => {
        const { errorMsgs } = this.state;
        const { idType, otherIdType } = questions;
        questions && Object.keys(questions).forEach(key => {
            this.isValid(questions[key], key);
        })
        
        if (idType === 3 && isStringEmpty(otherIdType)) {
            this.addError(errorList, 'otherIdType');
            errorMsgs['otherIdType'] = this.props.i18n.requireMsg;
        } else {
            this.removeErrorList(errorList, 'otherIdType');
        };
    }

    backAction = () => {
        history.push(paths.accountOpeningSteps.path);
    }

    onChangeNextSubmit = () => {
        this.validateForm()
        .then(() => {
            const { currentSection } = this.state;
            const { appInfo, savePQForm } = this.props;
            delete currentSection.privacy;
            if (currentSection.idType !== 3) delete currentSection.otherIdType;
            appInfo.idInfo = currentSection;
            this.setState({ disabled: true });
            return savePQForm({idInfo: {...currentSection}});
        })
        .then(response => {
            this.setState({ disabled: false });
            if (response && response.respCode === '200') {
                this.props.updateStep({"progressIndex": 0, "status": 1});
                history.push(paths.companyRegistration.path);
            }
        })
        .catch(error => {
            this.setState({ disabled: false });
        });
    }
    render() {
        const { i18n, appMessages, pageTitle } = this.props;
        const { currentSection, errorMsgs, errorList, disabled } = this.state;

        if (i18n && pageTitle) {
            setTitle( i18n.title + pageTitle);
        }

        return (i18n && currentSection) ? (
            <Grid className="dynamic-form ao-form pq-form">
                <StepIndicator currentStep={1} stepInfo={appMessages.stepInfo} stepTitle={appMessages.stepTitle} />
                <FormTitle content={{
                    title: {
                        text: i18n.title,
                        dataKey: 'applicant-information-title'
                    },
                    subTitle: {
                        text: i18n.subTitle,
                        dataKey: 'applicant-information-title'
                    },
                    optional_msg: { text: appMessages.form_base_content.optional_msg, dataKey: "optional_msg"}
                }} />
                <div className="applicant-information-container">
                    <ApplicantInformationItem
                        onChangeAnswerForm={this.onChangeAnswerForm}
                        currentSection={currentSection}
                        errorList={errorList}
                        errorMsgs={errorMsgs}
                        i18n={i18n}
                        onBlurAction={this.onBlurAction}
                    />
                    <AOForm.BottomButtonsGroup
                        disabled={disabled}
                        saveButtonShow={false}
                        content={i18n.bottomButtonsContent}
                        backAction={this.backAction}
                        completeFormAction={this.onChangeNextSubmit}
                    />
                </div>
            </Grid>
        ) : null
    }
}

ApplicantInformation.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = (state) => ({
    appInfo: state.app.businessInfo,
    i18n: state.applicantInformationReducer.i18n,
    applicantInformation: state.applicantInformationReducer,
    selectedLanguage: state.app.selectedLanguage,
    appMessages:state.app.i18n,
    pageTitle: state.app.i18n.pageTitle
});

export default connect(
    mapStateToProps, {
        savePQForm,
        updateStep,
        applicantInformationHandleAction
    }
)(ApplicantInformation);


// WEBPACK FOOTER //
// ./src/views/ApplicantInformation/container/ApplicantInformation.js